export const bizMetricsMap = {
  'view-user-attendance-list': 'view-user-attendance-list',
  'view-team-attendance-list': 'view-team-attendance-list',
};
